<template>
  <div>
    <Row v-show="false" class="viewer-img-box">
      <viewer :options="options" @inited="inited">
        <img ref="imgDom" :src="imgUrl" :data-source="imgUrl" alt="">
      </viewer>
    </Row>

    <Modal
      v-model="onlineWordModal"
      fullscreen
      :footer-hide="true"
    >
      <div slot="header" style="font-weight:700;font-size:18px">在线文档</div>
      <div style="height:100%;">
        <wps-file
          v-if="onlineWordModal"
          :file-url="onlineFileUrl"
          :read-only="readOnly"
        />
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    readOnly: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      options: {
        url: 'data-source'
      },
      imgUrl: '',
      onlineWordModal: false,
      onlineFileUrl: '',
      url: ''
    }
  },
  watch: {},
  created() {},
  beforeMount() {},
  mounted() {},
  updated() {},
  methods: {
    inited(viewer) {
      this.$viewer = viewer
    },
    async getUrl(key, type) {
      this.url = await this.common.getPublicUrl(key)
      this.initPreview(type)
    },
    preview(defaultData) {
      console.log('defaultData', defaultData);
      debugger
      const type = this.common.getFileType(defaultData.mediaType)
      this.url = defaultData.url
      if (defaultData.url && defaultData.url.indexOf('dev-private') != -1) {
        const arr = defaultData.url.split('?')[0].split('/')
        const key = arr[arr.length - 1]
        this.getUrl(key, type)
        debugger
      } else {
        debugger
        this.initPreview(type)
      }
    },
    initPreview(type) {
      console.log(111111111, type);
      if (type === 'image') {
        this.imgUrl = this.url
        this.$viewer.update()
        this.$refs['imgDom'].click()
      } else {
        this.onlineFileUrl = this.url
        this.onlineWordModal = true
      }
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/common/previewFile/previewFile.vue